import { VacuumCategoryInfo } from ".";
import { VacuumCategory } from "../core/alloy-types";
import * as VacuumElement from "../filter-logic/min-max-values";

export interface VacuumState {
  drawerOpen: boolean;
  openFilter: string;
  searchTerm: string | null;

  currentPage: number;
  rowsPerPage: number;
  
  selectedCategories: VacuumCategoryInfo[];

  cannonMuskegonTitleSelections: string[];
  aerospaceMaterialSpecificationsSelections: string[];
  prattAndWhitneySelections: string[];
  generalElectricSelections: string[];
  rollsRoycePlcSelections: string[];
  rollsRoyceCorpSelections: string[];
  honeywellSelections: string[];
  safranSelections: string[];

  cobaltFilterSet: boolean;
  cobaltMin: number;
  cobaltMax: number;
  chromiumFilterSet: boolean;
  chromiumMin: number;
  chromiumMax: number;
  niobiumFilterSet: boolean;
  niobiumMin: number;
  niobiumMax: number;
  tantalumFilterSet: boolean;
  tantalumMin: number;
  tantalumMax: number;
  rheniumFilterSet: boolean;
  rheniumMin: number;
  rheniumMax: number;
}

export const VACUUM_CATEGORIES = [
  { value: VacuumCategory.NiBaseEquiax, selected: true },
  { value: VacuumCategory.NiDirectionallySolidified, selected: true },
  { value: VacuumCategory.NiSingleCrystal, selected: true },
  { value: VacuumCategory.CobaltBase, selected: true }
];

export const INITIAL_STATE = {
  drawerOpen: false,
  openFilter: "", 
  searchTerm: null,

  currentPage: 1,
  rowsPerPage: 10,

  cannonMuskegonTitleSelections: [],
  aerospaceMaterialSpecificationsSelections: [],
  prattAndWhitneySelections: [],
  generalElectricSelections: [],
  rollsRoycePlcSelections: [],
  rollsRoyceCorpSelections: [],
  honeywellSelections: [],
  safranSelections: [],
  selectedCategories: VACUUM_CATEGORIES,
  cobaltFilterSet: false,
  cobaltMin: VacuumElement.cobaltInfo.minimum,
  cobaltMax: VacuumElement.cobaltInfo.maximum,
  chromiumFilterSet: false,
  chromiumMin: VacuumElement.chromiumInfo.minimum,
  chromiumMax: VacuumElement.chromiumInfo.maximum,
  niobiumFilterSet: false,
  niobiumMin: VacuumElement.niobiumInfo.minimum,
  niobiumMax: VacuumElement.niobiumInfo.maximum,
  tantalumFilterSet: false,
  tantalumMin: VacuumElement.tantalumInfo.minimum,
  tantalumMax: VacuumElement.tantalumInfo.maximum,
  rheniumFilterSet: false,
  rheniumMin: VacuumElement.rheniumInfo.minimum,
  rheniumMax: VacuumElement.rheniumInfo.maximum,
};
